import React, { Fragment, useState } from 'react';

// Material UI
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import Badge from '@mui/material/Badge';

// Icons
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';
import SpeakerNotesOffIcon from '@mui/icons-material/SpeakerNotesOff';
import NotificationsIcon from '@mui/icons-material/Notifications';

// Hooks
import useStyles from './styles';
import useNotifications from '../../../hooks/notify/useNotifications';

const NotifyMenu = () => {
    const { classes } = useStyles();
    const { notifications } = useNotifications();
    const [anchorEl, setAnchorEl] = useState(null);

    const FormatDate = (dateString) => {
        try {
            const date = new Date(dateString);
            const month = date.toLocaleDateString('default', { month: 'long' })
            const day = date.getDay();
            const year = date.getFullYear();
            const time = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

            return `${month} ${day}, ${year} - ${time}`;
        } catch (err) {
            return '';
        }
    }

    const GetIcon = (variant) => {
        switch (variant) {
            case 'warning': return <WarningIcon className={classes.warning} />
            case 'error': return <ErrorIcon className={classes.error} />
            default: return <InfoIcon className={classes.info} />
        }
    }

    const Message = ({ title, variant, message, date }) =>
        <div className={classes.item}>
            {
                title &&
                <div className={classes.title}>
                    {
                        variant &&
                        <Typography variant='subtitle1' gutterBottom>
                            {GetIcon(variant)}
                        </Typography>
                    }
                    <Typography variant='subtitle1' gutterBottom>
                        {title}
                    </Typography>
                </div>
            }
            <Typography variant='body2' gutterBottom>
                {message}
            </Typography>
            {
                date &&
                <Typography variant='caption' color="textSecondary">
                    {FormatDate(date)}
                </Typography>
            }
        </div>

    return (
        <>
            <IconButton
                variant="contained"
                color="inherit"
                onClick={(event) => setAnchorEl(event.currentTarget)}
                size="large"
            >
                <Badge color="error" badgeContent={notifications.length}>
                    <NotificationsIcon />
                </Badge>
            </IconButton>
            <Popover
                className={classes.root}
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}

            >
                {
                    notifications
                        .reverse()
                        .map((item, index) => (
                            <Fragment key={index}>
                                <Message {...item} />
                                {
                                    index < notifications.length - 1 &&
                                    <Divider />
                                }
                            </Fragment>
                        ))
                }
                {
                    notifications.length === 0 &&
                    <div className={classes.item}>
                        <div className={classes.title}>
                            <Typography variant='subtitle1'>
                                <SpeakerNotesOffIcon />
                            </Typography>
                            <Typography variant='subtitle1'>
                                Sin notificaciones
                            </Typography>
                        </div>
                    </div>
                }
            </Popover>
        </>
    );
}

export default NotifyMenu;